// extracted by mini-css-extract-plugin
module.exports = {"container":"forms-form_container__2zzpg","fields":"forms-form_fields__rDoIA","input":"forms-form_input__4-R0x","questions":"forms-form_questions__3d1bV"};